import { connect } from 'react-redux';
import ProductsTable from './ProductsTable';
import { setOpenModal } from '../../../../../store/modals/actions';
import { deleteProduct, fetchProductsData } from '../../../../../store/products/actions';
import { getProducts } from '../../../../../store/products/selectors';
import { getModals } from '../../../../../store/modals/selectors';

const mapStateToProps = (state) => ({
  modals: getModals(state),
  products: getProducts(state),
});

const mapDispatchToProps = (dispatch) => ({
  setOpenModal: (modal, value) => dispatch(setOpenModal(modal, value)),

  fetchProductsData: (
    filterName,
    filterValue,
  ) => dispatch(
    fetchProductsData(
      filterName,
      filterValue,
    ),
  ),

  deleteProduct: (
    productIRI,
  ) => dispatch(
    deleteProduct(
      productIRI,
    ),
  ),

});

export default connect(mapStateToProps, mapDispatchToProps)(ProductsTable);
